import { createContext } from "react";

import type { ChildClassification } from "../api/MediaAPI.types";

export interface ChildMedia {
  key: string | undefined;
  uuid: string;
  label: string;
  classificationLabel: string;
}

export interface ChildClassificationItem {
  key: string;
  uuid: string;
  classificationLabel: string;
}

export interface MasterMediaContextValues {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  childMediaList: ChildMedia[];
  childClassificationList: ChildClassificationItem[] | undefined;
  addChildMedia: (mediaClassification: ChildClassification) => Promise<void>;
  deleteChildMedia: (mediaId: string) => Promise<void>;
}

const MasterMediaContext = createContext<MasterMediaContextValues>(
  {} as MasterMediaContextValues,
);

export default MasterMediaContext;
